
export default {
  methods: {
    getErrorMessage (error) {
      let msg = ''

      if (error && error.response && error.response.data) {
        if (error.response.data.error) {
          console.log('Server error', error.response.data.error)
          msg = error.response.data.error.message
        }
      }

      return msg
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/ServerErrorMixin.js